<template>
  <div
    class="vignet"
  >
    <div
      style="display: flex; flex-direction: row;"
    >
      <v-icon
        v-if="testValue"
        color="green"
      >
        mdi-checkbox-marked-circle
      </v-icon>
      <v-icon
        v-else
        color="red"
      >
        mdi-close-circle
      </v-icon>

      <div
        style="display: flex; flex-direction: column; margin-left: 10px;"
      >
        <div style="font-weight: 800;">
          {{ $t(`controller.verificationTitle.${name}`) }}
        </div>

        <div> {{ testValueText() }} </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
    name: 'TestFormCSVThumbnail',

    props: {
        testValue: {
            type: Boolean,
            required: true,
        },
        name: {
            type: String,
            required: true,
        },
        controllerId: {
            type: String,
            required: true,
        },
        controllerIdInFile: {
            type: String,
            required: true,
        },
        missingProbes: {
            type: Array,
            required: true,
        },
        dateFormat: {
            type: String,
            required: true,
        },
        dateFormatInFile: {
            type: String,
            required: true,
        },

    },

    methods: {
        testValueText() {
            if (this.testValue) {
                return this.$t('controller.verificationText.correct');
            }
            switch (this.name) {
                case 'controllerId':
                    return this.$t('controller.verificationText.controllerId', { controllerIdInFile: this.controllerIdInFile, controllerId: this.controllerId });

                case 'probeId':
                    return this.$t('controller.verificationText.probeId', { missingProbes: this.missingProbes.join(', ') });

                case 'dateFormat':
                    return this.$t('controller.verificationText.dateFormat', { dateFormat: this.dateFormat, dateFormatInFile: this.dateFormatInFile });

                default:
                    return this.testValue;
            }
        },

    },


};

</script>

<style lang="scss" scoped>
.testCSVForm {
  .vignet{
    color: white;
    width: 100%;
    border-radius: 5px;
    margin-bottom: 15px;

  }

}
</style>
